@if (type == 'line') {

  <div class="chart-container" 
  [ngStyle]="containerStyle" [style.width.px]="typeof width === 'number' ? width : null" [style.width]="typeof width === 'string' ? width : null">
    <h4>{{ title }}</h4>
    
    <!-- <div class="orbe" style="z-index: -1;">
        <div class="blue-orbit leo"></div>
        <div class="green-orbit leo"></div>
        <div class="red-orbit leo"></div>

        <div class="white-orbit w1 leo"></div>
        <div class="white-orbit w2 leo"></div>
        <div class="white-orbit w3 leo"></div>
    </div> -->

    <apx-chart class="{{ 'chart-' + title }}"
      [series]="resolvedChartOptions.series!"
      [chart]="resolvedChartOptions.chart!"
      [xaxis]="resolvedChartOptions.xaxis!"
      [stroke]="resolvedChartOptions.stroke!"
      [dataLabels]="resolvedChartOptions.dataLabels!"
      [markers]="resolvedChartOptions.markers!"
      [legend]="resolvedChartOptions.legend!"
      [tooltip]="resolvedChartOptions.tooltip!"
      [grid]="resolvedChartOptions.grid!"
      [labels]="resolvedChartOptions.labels!"
    ></apx-chart>

  </div> 

}
@else {
  <div class="chart-container" 
  [ngStyle]="containerStyle" [style.width.px]="typeof width === 'number' ? width : null" [style.width]="typeof width === 'string' ? width : null">
    
    <apx-chart class="{{ 'chart-' + title }}"
        [series]="donutOptions.series!"
        [chart]="donutOptions.chart!"
        [dataLabels]="donutOptions.dataLabels!"
        [labels]="donutOptions.labels!"
      ></apx-chart>
  </div> 
}